module.exports = __webpack_public_path__ + "89053fa8bdc8b08ff74f23b32cdbe020.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/b_silver_large.svg
// module id = 984
// module chunks = 0